export const milestonesList = {
    en: {
        comingUp: [
            {
                title: 'Extending the benefits catalog',
                description: 'We have launched the application with 10 essential benefits. We are now working on extending the catalog to include more benefits. To ensure that we cover the most important benefits first, we will be collaborating with relevant stakeholders.',
                date: 'Late 2024',
            }, {
                title: 'Collaboration with municipalities',
                description: 'The current application is designed to be used by anyone living in Germany with little regard to their specific municipality. We will be working together with municipalities to extend the application to include benefits that are specific to certain regions.',
                date: 'Early 2025',
            }
        ],
        past: [
            {
                title: 'Successful application: NGI Search',
                description: 'We successfully applied to the NGI Search Program of the European Commission and will receive funding, mentorship and various support modules until mid 2025.',
                links: [{title: 'NGI Search', url: 'https://www.ngisearch.eu/'}],
                date: 'November 2024'
            },
            {
                title: 'Presentation at Public Makers Bootcamp',
                description: 'Ben presented FörderFunke and his personal journey of working in the public sector at the first Public Makers Bootcamp in Munich. ',
                links: [{title: 'Public Makers Bootcamp', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7253815779312238595/'}],
                date: 'October 2024'
            },
            {
                title: 'Presentation at "The Tech We Want Online Summit"',
                description: 'Benjamin presented FörderFunke at "The Tech We Want Online Summit", organized by the Open Knowledge Foundation.',
                links: [{title: 'The Tech We Want Online Summit', url: 'https://www.youtube.com/live/V7Sxo0IXe8g?t=20005s'}],
                date: 'October 2024'
            },
            {
                title: 'Workshop at NEGZ Autumn Conference',
                description: 'We held a workshop around the ideas of FörderFunke at the NEGZ Autumn Conference.',
                links: [{title: 'Workshop NEGZ Autumn Conference', url: 'https://negz.org/termin/negz-herbsttagung-zur-digitalen-verwaltung-2024/#WS5'}],
                date: 'September 2024'
            },
            {
                title: 'Launch of application at Prototype Fund Demo Day',
                description: 'As part of our participation in the Demo Day of the Prototype Fund, we have launched the ' +
                    'web application. The application currently includes 10 social benefits in Germany.',
                links: [{title: 'Prototype Fund Demo Day', url: 'https://prototypefund.de/demo-day/'}],
                date: 'September 2024',
            },
            {
                title: 'Presentation in Federal-State Working Group Meeting',
                description: 'Our project was presented as a "good practice example" in the meeting of the Federal-State Working Group "Citizen-Friendly Welfare State" (BMAS).',
                date: 'September 2024'
            },
            {
                title: 'Civic Coding',
                description: 'We received project consultation from Civic Coding on both technical and organization aspects.',
                links: [{title: 'Civic Coding', url: 'https://www.civic-coding.de/'}],
                date: 'May - September 2024'
            },
            {
                title: 'Finalists in Innovation Competition',
                description: 'We were selected as finalists in the Innovation Competition held by the City of Munich.',
                links: [{title: 'Munich Innovation Competition', url: 'https://stadt.muenchen.de/infos/innovationswettbewerb.html'}],
                date: 'July 2024'
            },
            {
                title: 'Participation in Datendialog',
                description: 'We participated in the Datendialog event hosted by the Bertelsmann Foundation and CorrelAid.',
                links: [{title: 'Datendialog', url: 'https://www.bertelsmann-stiftung.de/de/unsere-projekte/data-science/projektnachrichten/datendialog-hamburg-juni-2024'}],
                date: 'June 2024'
            },
            {
                title: 'Presentation at Digitale Woche Kiel',
                description: 'We presented our project during the Digital Week Kiel, focusing on Solid as a data storage solution we would like to adopt.',
                links: [{title: 'Presentation Digitale Woche Kiel', url: 'https://digitalewochekiel.de/'}],
                date: 'May 2024'
            },
            {
                title: 'Presentation to Working Group on Semantic Interoperability',
                description: 'We were invited to present FörderFunke as a use case for Linked Open Data to the Working Group "Semantic Interoperability" of the IT-Planungsrat.',
                links: [{title: 'IT-Planungsrat', url: 'https://www.it-planungsrat.de/'}],
                date: 'April 2024'
            },
            {
                title: 'Beginning of Prototype Fund period',
                description: 'Late in 2023 we were selected to participate in the 15th round of the Prototype Fund. The funding period began in March 2024 and lasted for 6 months. The funding and additional support schemes provided us with an invaluable opportunity to get the application from an idea to a working prototype.',
                links: [{title: 'Prototype Fund', url: 'https://prototypefund.de/project/foerderfunke/'}],
                date: 'March 2024',
            },
            {
                title: 'Video for Creative Bureaucracy Festival',
                description: 'For the Digital Kick-Off Day of the Creative Bureaucracy Festival we produced a 7 min video.',
                links: [{title: 'Video submission', url: 'https://youtu.be/fDWfGEXvqjk'}],
                date: 'March 2024',
            },
            {
                title: 'Best Poster Award',
                description: 'Benjamin received the Best Poster Award in the "Linked Data & Solid" online course at the University of Ghent.',
                links: [{title: 'Poster Award', url: 'https://www.linkedin.com/posts/bdegenhart_linkeddata-semanticweb-solid-activity-7168706749070262275-S5Qu/'}],
                date: 'January 2024',
            },
            {
                title: 'Article in Tagesspiegel Background',
                description: 'In July 2023, Helen Bielawa wrote an article about the concept in the Tagesspiegel Background, titled "Proaktive Verwaltung als Selfmade-Lösung".',
                links: [{title: 'Article', url: 'https://background.tagesspiegel.de/smart-city-und-stadtentwicklung/briefing/proaktive-verwaltung-als-selfmade-loesung'}],
                date: 'July 2023',
            }
        ]
    },
    de: {
        comingUp: [
            {
                title: 'Erweiterung des Leistungskatalogs',
                description: 'Wir haben die Webanwendung mit 10 essenziellen Leistungen gestartet. Jetzt arbeiten wir ' +
                    'daran, das Angebot um zusätzliche Leistungen zu erweitern. Damit wir uns auf die wichtigsten ' +
                    'Leistungen konzentrieren können, werden wir mit den relevanten Interessen- und Zielgruppen ' +
                    'zusammenarbeiten.',
                date: 'September 2024',
            },
            {
                title: 'Zusammenarbeit mit Städten und Gemeinden',
                description: 'Die aktuelle Anwendung enthält bisher in erster Linie Leistungen, die deutschlandweit ' +
                    'verfügbar sind. In einer nächsten Phase möchten wir eng mit Städten und Gemeinden zusammenarbeiten, ' +
                    'um zusätzliche Leistungen aufzunehmen, die spezifisch ein lokal oder regionales Angebot abbilden.',
                date: 'Anfang 2025',
            }
        ],
        past: [
            {
                title: 'Erfolgreiche Bewerbung: NGI Search',
                description: 'Wir haben uns erfolgreich für das NGI Search Programm der Europäischen Kommission beworben und werden bis Mitte 2025 Fördermittel, Mentoring und verschiedene Unterstützungsmodule erhalten.',
                links: [{title: 'NGI Search', url: 'https://www.ngisearch.eu/'}],
                date: 'November 2024'
            },
            {
                title: 'Präsentation beim Public Makers Bootcamp',
                description: 'Ben präsentierte FörderFunke und erzählte von seine Erfahrungen im öffentlichen Sektor auf dem ersten Public Makers Bootcamp in München.',
                links: [{title: 'Public Makers Bootcamp', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7253815779312238595/'}],
                date: 'Oktober 2024'
            },
            {
                title: 'Präsentation beim "The Tech We Want Online Summit"',
                description: 'Benjamin präsentierte FörderFunke auf dem "The Tech We Want Online Summit", organisiert von der Open Knowledge Foundation.',
                links: [{title: 'The Tech We Want Online Summit', url: 'https://www.youtube.com/live/V7Sxo0IXe8g?t=20005s'}],
                date: 'Oktober 2024'
            },
            {
                title: 'Workshop bei der NEGZ-Herbsttagung',
                description: 'Auf der NEGZ-Herbsttagung haben wir einen Workshop zu den Ideen der FörderFunke veranstaltet.',
                links: [{title: 'Workshop NEGZ-Herbsttagung', url: 'https://negz.org/termin/negz-herbsttagung-zur-digitalen-verwaltung-2024/#WS5'}],
                date: 'September 2024'
            },
            {
                title: 'Vorstellung des MVP beim Prototype Fund Demo Day',
                description: 'Im Rahmen unserer Teilnahme am Demo Day des Prototype Fund haben wir den MVP der Webanwendung vorgestellt. Die Anwendung umfasst derzeit 10 Sozialleistungen in Deutschland.',
                links: [{title: 'Prototype Fund Demo Day', url: 'https://prototypefund.de/demo-day/'}],
                date: 'September 2024',
            },
            {
                title: 'Präsentation vor Bund-Länder-Arbeitsgruppe',
                description: 'Unser Projekt wurde als "Good-Practice-Beispiel" in der Sitzung der Bund-Länder-Arbeitsgruppe "Bürgerfreundlicher Sozialstaat" (BMAS) vorgestellt.',
                date: 'September 2024'
            },
            {
                title: 'Civic Coding Projektberatung',
                description: 'Wir wurden von Civic Coding sowohl in technischer als auch in organisatorischer Hinsicht beraten.',
                links: [{title: 'Civic Coding', url: 'https://www.civic-coding.de/'}],
                date: 'Mai - September 2024'
            },
            {
                title: 'Finalist Innovationwettbewerb München',
                description: 'Wir wurden als Finalisten für den Innovationswettbewerb der Stadt München ausgewählt.',
                links: [{title: 'Munich Innovation Competition', url: 'https://stadt.muenchen.de/infos/innovationswettbewerb.html'}],
                date: 'Juli 2024'
            },
            {
                title: 'Teilnahme am Bertelsmann Datendialog',
                description: 'Wir haben an der Veranstaltung Datendialog teilgenommen, die von der Bertelsmann-Stiftung und CorrelAid ausgerichtet wurde.',
                links: [{title: 'Datendialog', url: 'https://www.bertelsmann-stiftung.de/de/unsere-projekte/data-science/projektnachrichten/datendialog-hamburg-juni-2024'}],
                date: 'Juni 2024'
            },
            {
                title: 'Präsentation bei der Digitalen Woche Kiel',
                description: 'Wir haben unser Projekt auf der Digitalen Woche Kiel vorgestellt und uns dabei auf Solid als Datenspeicherlösung konzentriert, die wir gerne einsetzen würden.',
                links: [{title: 'Präsentation Digitale Woche Kiel', url: 'https://digitalewochekiel.de/'}],
                date: 'Mai 2024'
            },
            {
                title: 'Präsentation bei der Arbeitsgruppe Semantische Interoperabilität',
                description: 'Wir wurden eingeladen, FörderFunke als Anwendungsfall für Linked Open Data in der Arbeitsgruppe "Semantische Interoperabilität" des IT-Planungsrates vorzustellen.',
                links: [{title: 'IT-Planungsrat', url: 'https://www.it-planungsrat.de/'}],
                date: 'April 2024'
            },
            {
                title: 'Start der Prototype Fund Förderperiode',
                description: 'Ende 2023 wurden wir für die Teilnahme an der 15. Runde des Prototypenfonds ausgewählt. Der Förderzeitraum begann im März 2024 und dauerte 6 Monate. Die Finanzierung und die zusätzlichen Unterstützungsprogramme boten uns die Gelegenheit, die Anwendung von einer Idee zu einem funktionierenden Prototyp zu entwickeln.',
                links: [{title: 'Prototype Fund', url: 'https://prototypefund.de/project/foerderfunke/'}],
                date: 'März 2024',
            },
            {
                title: 'Video für das Creative Bureaucracy Festival',
                description: 'Für den Digital Kick-Off Day des Creative Bureaucracy Festivals haben wir ein 7-minütiges Video produziert.',
                links: [{title: 'Video Beitrag', url: 'https://youtu.be/fDWfGEXvqjk'}],
                date: 'März 2024',
            },
            {
                title: 'Best Poster Award',
                description: 'Benjamin erhielt den Preis für das beste Poster im Online-Kurs "Linked Data & Solid" an der Universität Gent.',
                links: [{title: 'Poster Award', url: 'https://www.linkedin.com/posts/bdegenhart_linkeddata-semanticweb-solid-activity-7168706749070262275-S5Qu/'}],
                date: 'Januar 2024',
            },
            {
                title: 'Artikel im Tagesspiegel Background',
                description: 'Im Juli 2023 schrieb Helen Bielawa einen Artikel über das Konzept im Tagesspiegel Background mit dem Titel "Proaktive Verwaltung als Selfmade-Lösung".',
                links: [{title: 'Artikel', url: 'https://background.tagesspiegel.de/smart-city-und-stadtentwicklung/briefing/proaktive-verwaltung-als-selfmade-loesung'}],
                date: 'Juli 2023',
            }
        ]
    }
}
